<div class="container-fluid">
    <div>
        <app-audit-configuration-header
         (searchByName)="searchByName($event)" 
         [tableSettings]="tableSetting.columns"
         (exportExcel)="exportAuditData($event)"></app-audit-configuration-header>
    </div>
    <div class="mt-1">
        <table class="table">
            <thead>
                <tr >
                    <td class="w-8" *ngFor="let column of tableSetting.columns;let i = index">
                          <div *ngIf="column.isSortable">                          
                              <span class="columheader" style="cursor:pointer">{{column.title}}</span>                   
                              <span class="icon-ic_filtered column-filter-icon cursor-pointer"  (click)="showSortingPopup(column)" *ngIf="column.isFilterIcon"></span>                             
                          </div>
                          <div  *ngIf="!column.isSortable">
                              <span class="columheader">{{column.title}}</span>
                          </div>
                          <div class="resource-dropdown" *ngIf="column.displaysort">
                             <app-audit-configuration-filter [actionPerformedOnArray] = "actionPerformedOnArray"
                             [actionPerformedArray] = "actionPerformedArray"
                              [column]="column" [tableSettings]="tableSetting" 
                              (gridFiltersApplied)="checkFilterApplied($event)"></app-audit-configuration-filter>
                          </div>
                    </td>
                </tr>
            </thead>
            <tbody class="results-list-panel">
              <div class="no-search-results" *ngIf="((configList!=null)&&(configList.length==0))">
                <span class="icon-ic_Search_NEG_circle"></span>
                <label>No results found</label>
              </div>
             <tr *ngFor="let d of configList">                 
              <td>
                  <span class="showellipsis" placement="right" tooltip="{{d.actionPerformedOn}}">{{d.actionPerformedOn}}</span>
                </td>            
                <td>       
                  <span class="showellipsis1">{{d.messageText}}</span>
                </td>
                <td>
                  <span class="showellipsis">{{d.actionPerformed}}</span>
                </td>
                <td>
                  <span class="showellipsis">{{d.changedBy}}</span>
                </td>
                <td>
                  <span class="showellipsis" placement="left" tooltip="{{d.changedDate | date:'d/MMM/y, h:mm a'}}">{{d.changedDate | date:'d/MMM/y, h:mm a'}}</span>
                </td>              
                
              </tr>
            </tbody>
            </table>
          </div>
        <div class="paginationwithcount" *ngIf="((configList!=null)&&(configList.length>0))" (click)="hideDropdowns()">
              <span class="mb-4 mx-4">Page</span>
              <pagination 
                          [(ngModel)]="filterData.page"
                          [boundaryLinks]="true" 
                          (pageChanged)="changeCurrentPage($event);p = $event"
                          [(totalItems)] = "totalCount"
                          [maxSize]="5"
                          firstText="&shy;"
                          lastText="&shy;"
                          previousText="&shy;"
                          nextText="&shy;"
                          [rotate]="false"
                          [itemsPerPage] = "itemsperPage"
                          >
              </pagination>  
          </div>
          <div class="totalcount" *ngIf="((configList!=null)&&(configList.length>0))"><span>{{((filterData.page -1) * itemsperPage )+ 1}} - {{ countLength }} of <b>{{totalCount}}</b></span>
          </div>     
    </div>
  